// extracted by mini-css-extract-plugin
module.exports = {"checkLabel":"EncxxKnJWFygu9YinkAR4Q==","icon":"_1w9-JtAVEU-p47fiNzHL6g=="};